exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--sort__yfkU_{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.styles--item__3ODFY{background:#79a5d2;padding:10px;border-radius:5px;-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2;max-width:500px;margin-top:5px;-webkit-box-sizing:border-box;box-sizing:border-box}.styles--image__1XTpc{background-size:cover;width:100px;height:100px}\n", ""]);

// exports
exports.locals = {
	"sort": "styles--sort__yfkU_",
	"item": "styles--item__3ODFY",
	"image": "styles--image__1XTpc"
};